<template>
    <div class="szolgaltatas_box_container">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>
    <GrcWidgetLoading v-show="IsWidgetLoading" />

    <div class="szolgaltatas_box_wrapper" v-show="IsWidgetLoading==false">

        <div class="item_cont">
            <span v-show="(BiztLista.length+KRITIKUS.length)==0">Önnek nincs biztosítása<br><br></span>


            <div style="width:100%; box-sizing:border-box; margin:30px 0px;" v-show="KRITIKUS.length>0">

                <div style="width:100%; box-sizing:border-box; margin:20px 0px; font-weight:500; text-align:center; font-size: 18px; line-height: 26px; padding: 8px; background-color: #e0e0e0; color: #000;">
                    Jóváhagyott keret igények
                </div>
                
                <div class="tbl_header">
                        <div class="item_tablerow">
                            <div class="item_col item_col_fv_left">
                                Azonosító
                            </div>
                            <div class="item_col">
                                Jóváhagyva
                            </div>
                            <div class="item_col">
                                Kezdet
                            </div>
                            <div class="item_col">
                                Keret vége
                            </div>
                            <div class="item_col">
                                Keret összeg
                            </div>

                        </div>
                </div>


                <div class="item_table" v-for="(item, index)  in KRITIKUS" v-bind:key="index">


                        <div class="item_tablerow">
                            <div class="item_col">
                                <div class="item_col_ft">Azonosító:</div>
                                <div class="item_col_fv item_col_fv_left">{{item.Megnevezes}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Jóváhagyva:</div>
                                <div class="item_col_fv">{{item.Jovahagyva}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Kezdet:</div>
                                <div class="item_col_fv">{{item.Kezdet}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Keret vége:</div>
                                <div class="item_col_fv">{{item.Befejezes}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Keret összeg:</div>
                                <div class="item_col_fv">{{item.Osszeg}}</div>
                            </div>
                        </div>


                </div>
            </div>


            <div style="width:100%; box-sizing:border-box;" v-show="BiztLista.length>0">
                
                <div style="width:100%; box-sizing:border-box; margin:20px 0px; font-weight:500; text-align:center; font-size: 18px; line-height: 26px; padding: 8px; background-color: #e0e0e0; color: #000;"
                v-show="KRITIKUS.length>0">
                    Biztosítások
                </div>


                <div class="tbl_header">
                        <div class="item_tablerow">
                            <div class="item_col item_col_fv_left">
                                Termék neve
                            </div>
                            <div class="item_col">
                                Biztosításhoz való csatlakozás dátuma
                            </div>
                            <div class="item_col">
                                Kockázatviselés kezdete
                                <br>(várakozási idő figyelembevételével)
                            </div>
                            <div class="item_col">
                                Kockázatviselés vége (díjfizetés szerint)
                            </div>
                            <div class="item_col">
                                Státusz
                            </div>

                        </div>
                </div>


                <div class="item_table" v-for="(item, index)  in BiztLista" v-bind:key="index">


                        <div class="item_tablerow">
                            <div class="item_col">
                                <div class="item_col_ft">Termék neve:</div>
                                <div class="item_col_fv item_col_fv_left">{{item.Megnevezes}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Biztosításhoz való csatlakozás dátuma:</div>
                                <div class="item_col_fv">{{item.CsatlakozasDatuma}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Kockázatviselés kezdete<br>(várakozási idő figyelembevételével):</div>
                                <div class="item_col_fv">{{item.Kezdet}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Kockázatviselés vége (díjfizetés szerint):</div>
                                <div class="item_col_fv">{{item.Befejezes}}</div>
                            </div>
                            <div class="item_col">
                                <div class="item_col_ft">Státusz:</div>
                                <div class="item_col_fv">{{item.StatuszNev}}</div>
                            </div>
                        </div>


                </div>
            </div>
        </div>


    </div>

    </div>
</template>

<script>

import axios from "axios";
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcWidgetLoading from '../GrcComponents/GrcWidgetLoading.vue'


export default {
  name: 'frmDashboard_BiztLista',
  components: {
      GrcDB,
      GrcButton,
      GrcDialog,
      GrcWidgetLoading
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmDashboard_BiztLista",
          IsWidgetLoading: false,

          BiztLista:[],
          KRITIKUS:[],
      }
  },
  model: {
  },  
  methods:{

      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      SetToDefault()
      {
        this.IsWidgetLoading = true;
      },


      Init()
      {
         this.BiztLista = [];
         this.KRITIKUS = [];

        this.IsWidgetLoading = true;

        var QP = {
          sSessionID: "[APPSESSIONID]",
          iUgyfelID: gDashboardUgyfelID,
        };
        var Q;

        this.$refs.GRCDB.GetData(this.WSPREFIX+"_GetData", QP).then(res => { 
            Q = res; 
            this.IsWidgetLoading = false;

            if (Q.APPERR[0].ERR != "")
            {
                //alert(Q.APPERR[0].ERR);
                return;
            }

            this.BiztLista = Q.RESULT;
            this.KRITIKUS = Q.KRITIKUS;
        });
      },


    async ShowInfo(pText)
    {
        window.open(pText, "_blank");
    },



  },
  created()
  {

  },
  mounted()
  {
      

  }

}


</script>


<style scoped>

.item_cont
{
    width:100%;
    box-sizing: border-box;
    padding:0px 0px;
    font-size:18px;
    line-height:24px;
    text-align: left;
}


.item_table
{
    width: 100%;
    box-sizing: border-box;
    display: inline-block;    
    border: solid 0px #ccc;
    margin-bottom: 4px;
    border-radius: 0px;
    color: var(--themecolor1);
}


.item_tablerow
{
    width:100%;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    border-top:solid 1px #ccc;
}


.item_col
{
    width: 20%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: inline-block;
    font-weight: 500;
    vertical-align: top;
    text-align: center;
}


.tbl_header
{
    color:var(--themecolor3);
}

.tbl_header .item_tablerow
{
    border:none;
}

.item_col_ft
{
    width:100%;
    box-sizing: border-box;
    display: none;
    text-align: left;
    color:#000;
    font-size:13px;
    line-height: 18px;
    font-weight: normal;
}

.item_col_fv
{
    width:100%;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
}

.item_col_fv_left
{
    text-align: left;
}

@media (max-width:800px)
{
    .item_col
    {
        width:100%;
    }

    .item_col_ft
    {
        display: inline-block;
    }

    .item_col_fv_left
    {
        text-align: center;
    }

    .tbl_header
    {
        display:none;
    }

}





</style>